<template>
  <BaseTransitionAnimation>
    <div
      v-if="show"
      class="badge__container"
      :class="`badge__container--${type}`"
    >
      <div class="badge__content">
        <SvgAsset
          class="badge__icon badge__icon-colored"
          :content="icon"
        />
        <span class="badge__message"> {{ text }} </span>
      </div>

      <button
        class="badge__close"
        @click="$emit('close')"
      >
        <SvgAsset
          class="badge__icon badge__icon-close"
          :content="crossMobilePath"
        />
      </button>
    </div>
  </BaseTransitionAnimation>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import crossMobilePath from '@/assets/images/svg/cross--mobile.svg?raw';
  import BaseTransitionAnimation from '@/components/BaseComponents/BaseTransitionAnimation.vue';

  const TIMEOUT = 2500;

  export default defineNuxtComponent({
    name: 'NotificationBadge',

    components: {
      SvgAsset,
      BaseTransitionAnimation,
    },

    props: {
      type: {
        type: String as PropType<'error' | 'warning'>,
        default: 'error',
      },

      show: {
        type: Boolean as PropType<boolean>,
        required: true,
      },

      text: {
        type: String as PropType<string>,
        required: true,
      },

      icon: {
        type: String as PropType<string>,
        required: true,
      },
    },

    computed: {
      crossMobilePath: () => crossMobilePath,
    },

    watch: {
      show() {
        setTimeout(() => {
          this.$emit('close');
        }, TIMEOUT);
      },
    },
  });
</script>

<style lang="scss" scoped>
  .badge {
    &__container {
      display: flex;
      width: 440px;
      position: fixed;
      z-index: 3;
      bottom: 24px;
      left: 16px;
      background: white;
      border: 1px solid $border-color--1;
      border-radius: 32px;
      padding: 16px 20px;

      &--error {
        color: $text-error-color--1;
        .badge__icon-colored {
          :deep() {
            svg path {
              fill: $text-error-color--1;
            }
          }
        }
      }
    }

    &__close {
      width: 24px;
      height: 24px;
    }

    &__content {
      @include normalText;
      font-family: $text-font--1;
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;
    }

    &__icon {
      width: 24px;
      height: 24px;

      &-colored {
        margin-left: -$spacing-1;
      }

      &-close {
        :deep() {
          svg path {
            fill: #969698;
          }
        }
        transition: 0.2s all ease-in;

        @include hover {
          :deep() {
            svg path {
              fill: #000000;
            }
          }
        }
      }
    }
  }
</style>
